import { render, staticRenderFns } from "./teacherDetails.vue?vue&type=template&id=11a68eec&scoped=true&"
import script from "./teacherDetails.vue?vue&type=script&lang=js&"
export * from "./teacherDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a68eec",
  null
  
)

export default component.exports